export default __webpack_public_path__ + "static/media/640_private03-en-web.984dd385.png";